import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import MegaFeiraoStamp from '@/modern/components/Stamps/MegaFeirao'
import TagCertified from '../TagCertified'
import TagBlackFeirao from '../TagBlackFeirao'
import TagDefaultFeirao from '../TagDefaultFeirao'
import './Tags.scss'

const Tags = props => {
  const {
    isCertified,
    certified,
    isDefaultFeirao,
    isBlackFeirao,
    align,
    lite,
    className,
    isMegaFeirao,
  } = props

  const tagStyles = {}

  if (align) tagStyles.justifyContent = align

  const tagCertified = isCertified && <TagCertified certified={certified} />

  let tagFeirao

  if (isBlackFeirao) {
    tagFeirao = <TagBlackFeirao width="119px" height="20px" />
  } else if (isMegaFeirao) {
    tagFeirao = <MegaFeiraoStamp variation="DA" />
  } else if (isDefaultFeirao) {
    tagFeirao = <TagDefaultFeirao />
  }

  const tagClass = classNames('Tags', {
    'Tags--lite': lite,
    [className]: className,
  })

  return (
    <div className={tagClass} style={tagStyles}>
      {tagCertified}

      {tagFeirao}
    </div>
  )
}

Tags.defaultProps = {
  isCertified: false,
  certified: {
    src: '',
    name: '',
  },
  isDefaultFeirao: false,
  isBlackFeirao: false,
  align: 'center',
  lite: false,
  className: null,
}

Tags.propTypes = {
  isCertified: PropTypes.bool,
  certified: PropTypes.shape({
    src: PropTypes.string,
    name: PropTypes.string,
  }),
  isDefaultFeirao: PropTypes.bool,
  isBlackFeirao: PropTypes.bool,
  align: PropTypes.string,
  lite: PropTypes.bool,
  className: PropTypes.string,
}

export default Tags
